import Vue from 'vue'
import FileSaver from 'file-saver'
import XLSX from 'xlsx'

Vue.use(FileSaver);
Vue.use(XLSX);

/**
 * 通用工具类
 */
export class CommonUtil {
  /**
   * 获得当天零点
   */
  static getToday() {
    let today = new Date();
    today.setHours(0);
    today.setMinutes(0);
    today.setSeconds(0);
    today.setMilliseconds(0);
    return today;
  }

  /**
   * 日期范围控件快键键
   * @returns {{shortcuts: *[]}}
   */
  static dateRangePickerOptions() {
    return {
      shortcuts: [{
        text: '最近三天',
        onClick: picker => {
          const end = this.getToday();
          const start = this.getToday();
          end.setTime(start.getTime() + 3600 * 1000 * 24 * 3);
          picker.$emit('pick', [start, end]);
        }
      }, {
        text: '最近一周',
        onClick: picker => {
          const end = this.getToday();
          const start = this.getToday();
          end.setTime(start.getTime() + 3600 * 1000 * 24 * 7);
          picker.$emit('pick', [start, end]);
        }
      }, {
        text: '最近一个月',
        onClick: picker => {
          const end = this.getToday();
          const start = this.getToday();
          end.setTime(start.getTime() + 3600 * 1000 * 24 * 30);
          picker.$emit('pick', [start, end]);
        }
      }, {
        text: '最近三个月',
        onClick: picker => {
          const end = this.getToday();
          const start = this.getToday();
          end.setTime(start.getTime() + 3600 * 1000 * 24 * 90);
          picker.$emit('pick', [start, end]);
        }
      }]
    };
  }

  /**
   * 通过用户昵称 和 用户信息获得用户称谓
   * @param user
   */
  static getUserTitle(user) {
    if (!user) {
      return null;
    }
    let userInfo = user.userInfo;
    if (!userInfo) {
      if (user.name) {
        return user.name;
      } else {
        return null;
      }
    } else {
      if (userInfo.sex) {
        // if (userInfo.age && userInfo.age >= 40) {
        return user.name + "先生";
        //   } else {
        //     return user.name + "帅哥";
        //   }
      } else {
        //   if (userInfo.age && userInfo.age >= 40) {
        return user.name + "女士";
        // } else {
        //   return user.name + "美女";
        // }
      }
    }
  }

  /**
   * 通用状态描述
   * @param user
   */
  static commonStatusFormat(status) {
    switch (status) {
      case "EFFECTIVE":
        return "有效的";
      case "DISABLED":
        return "已失效";
    }
    return "";
  }

  /**
   * 返回 状态列表
   */
  static getCommonStatusList() {
    let rst = [];
    rst.push({id: 'EFFECTIVE', name: '有效的'});
    rst.push({id: 'DISABLED', name: '已失效'});
    return rst;
  }

  /**
   * 资讯状态描述
   * @param user
   */
  static informationStatusFormat(status) {
    switch (status) {
      case "SAVE":
        return "保存";
      case "EFFECTIVE":
        return "有效的";
      case "DISABLED":
        return "已失效";
      case "ADMIN_DISABLED":
        return "系统管理员禁用";
    }
    return "";
  }

  /**
   * 返回 资讯状态列表
   */
  static getInformationStatusList() {
    let rst = [];
    rst.push({id: 'SAVE', name: '保存'});
    rst.push({id: 'EFFECTIVE', name: '有效的'});
    rst.push({id: 'DISABLED', name: '已失效'});
    rst.push({id: 'ADMIN_DISABLED', name: '系统管理员禁用'});
    return rst;
  }

  static exportExcel(tableId, fileName) {
    /* generate workbook object from table */
    var wb = XLSX.utils.table_to_book(document.querySelector("#" + tableId))
    /* get binary string as output */
    var wbout = XLSX.write(wb, {bookType: 'xlsx', bookSST: true, type: 'array'})
    try {
      FileSaver.saveAs(new Blob([wbout], {type: 'application/octet-stream'}), fileName + '.xlsx')
    } catch (e) {
      if (typeof console !== 'undefined') console.log(e, wbout)
    }
    return wbout
  }

  /**
   * 食物推荐等级
   */
  static getFoodLevelList() {
    return ["推荐", "可以", "不推荐"]; // 推荐等级
  }

  /**
   * 返回 支付状态列表
   */
  static getPayStatusList() {
    let rst = [];
    rst.push({id: 'PAYING', name: '支付中'});
    rst.push({id: 'CANCEL', name: '超时未支付'});
    rst.push({id: 'PAID', name: '已支付'});
    rst.push({id: 'REFUND', name: '已退款'});
    return rst;
  }

  /**
   * 返回 食物 餐次列表
   */
  static getMealTimeList() {
    return ["早餐-主食", "早餐-辅食", "午晚-主食", "午晚-菜式", "加餐-主食", "加餐-其他"];
  }

  /**
   * 返回 食物 口味列表
   */
  static getFlavorList() {
    return ["麻辣", "清淡", "咸鲜", "酸甜", "酱香", "微辣", "怪味", "海鲜"];
  }

  /**
   * 支付状态描述
   * @param user
   */
  static payStatusFormat(status) {
    switch (status) {
      case "PAYING":
        return "支付中";
      case "CANCEL":
        return "超时未支付";
      case "PAID":
        return "已支付";
      case "REFUND":
        return "已退款";
    }
    return "";
  }

  /**
   * 小程序订单状态描述
   * @param user
   */
  static maOrderStatusFormat(status) {
    switch (status) {
      case "UNRECEIVED":
        return "未领取";
      case "RECEIVED":
        return "已领取";
    }
    return "";
  }
}



// WEBPACK FOOTER //
// ./src/global.js